// import React, { useEffect, useState } from "react";
// import StatusCard from "../../../Components/StatusCard/StatusCard";
// import { Button, Grid } from "@mui/material";
// import toal_user_icon from "../../../Assets/toal_user_icon.svg";
// import total_refer_icon from "../../../Assets/total_refer_icon.svg";
// import total_register_icon from "../../../Assets/total_register_icon.svg";
// import gold_puschased_icon from "../../../Assets/gold_puschased_icon.svg";
// import toal_gold_matured_icon from "../../../Assets/toal_gold_matured_icon.svg";
// import total_redeem_icon from "../../../Assets/total_redeem_icon.svg";
// import { LuSquareChevronRight } from "react-icons/lu";
// import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
// import { CgChevronLeft, CgChevronLeftR, CgChevronRightR } from "react-icons/cg";

// import {
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   IconButton,
//   Divider,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import {
//   ArrowBack,
//   ArrowForward,
//   ArrowLeft,
//   ArrowRight,
//   ArrowRightAltOutlined,
// } from "@mui/icons-material";
// import GradientLineChart from "../../../Components/GraphStake/GradientLineChart";
// import TotalOnboarding from "./TotalOnboarding";
// import actions from "../../../ReduxStore/actions";
// import { useDispatch, useSelector } from "react-redux";

// // Gold Stake Schemes Component
// const GoldStakeSchemesData = [
//   {
//     header: "Member Profit",
//     subheader: "Since Last Month",
//     value: "+53411",
//   },
//   {
//     header: "Overdue",
//     subheader: "Since Last Month",
//     value: "+53411",
//   },
//   {
//     header: "Support",
//     subheader: "Since Last Month",
//     value: "+53411",
//   },
//   {
//     header: "Dividents",
//     subheader: "Since Last Month",
//     value: "+53411",
//   },
// ];

// const TotalGoldStaked = () => {
//   const [selectedDate, setSelectedDate] = useState("Today");

//   const [graphData, setGraphData] = useState({
//     Today: {
//       value: "$200.123",
//       percentage: "+5.15(+20%)",
//       stats: ["20% Growth", "40% Disbursed", "40% Withdraw"],
//       graph: [
//         { name: "Point 1", value: 20 },
//         { name: "Point 2", value: 40 },
//         { name: "Point 3", value: 25 },
//         { name: "Point 4", value: 50 },
//         { name: "Point 5", value: 35 },
//       ],
//     },
//     Yesterday: {
//       value: "$180.456",
//       percentage: "+3.50(+15%)",
//       stats: ["15% Growth", "50% Disbursed", "35% Withdraw"],
//       graph: [
//         { name: "Point 1", value: 10 },
//         { name: "Point 2", value: 100 },
//         { name: "Point 3", value: 20 },
//         { name: "Point 4", value: 45 },
//         { name: "Point 5", value: 25 },
//       ],
//     },
//   });

//   // Handler for dropdown change
//   const handleDateChange = (event) => {
//     setSelectedDate(event.target.value);
//   };

//   const currentData = graphData[selectedDate];

//   return (
//     <Card
//       sx={{
//         paddingX: 2,
//         py: 2,
//         boxShadow: 2,
//         height: "350px",
//       }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <Typography variant="body1" fontWeight="bold" fontSize="17px">
//           Total Gold Staked
//         </Typography>

//         <Select
//           value={selectedDate}
//           onChange={handleDateChange}
//           size="small"
//           variant="outlined"
//           sx={{
//             width: "80px",
//             fontSize: "13px",
//             height: "30px",
//             "& .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#C38F51",
//             },
//             "&:hover .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#C38F51",
//             },
//             "& .MuiSelect-select": {
//               color: "#C38F51",
//             },
//           }}
//         >
//           <MenuItem value="Today">Today</MenuItem>
//           <MenuItem value="Yesterday">Yesterday</MenuItem>
//         </Select>
//       </Box>
//       <Divider sx={{ marginTop: 1, width: "100%" }} />

//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mt: 2,
//         }}
//       >
//         <Typography
//           variant="h3"
//           fontWeight="bold"
//           color="black"
//           sx={{ fontSize: "28px" }}
//         >
//           {currentData.value}
//         </Typography>
//         <Typography variant="body2" color="#C38F51" fontSize="12px">
//           {currentData.percentage}
//         </Typography>
//       </Box>
//       {/* <GradientLineChart data={currentData} /> */}
//       <GradientLineChart data={currentData.graph} />

//       <Box
//         sx={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}
//       >
//         {currentData.stats.map((stat, index) => (
//           <Box key={index} textAlign="center">
//             <Typography variant="body1" fontWeight="800">
//               {stat.split(" ")[0]}
//             </Typography>
//             <Typography
//               variant="body2"
//               sx={{ color: "#C38F51", fontSize: "12px" }}
//             >
//               {stat.split(" ")[1]}
//             </Typography>
//           </Box>
//         ))}
//       </Box>
//     </Card>
//   );
// };
// // // Main Dashboard Component
// // const Dashboard = () => (
// //   <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 2, padding: 2 }}>
// //     <GoldStakeSchemes />
// //     <ReferralSchemes />
// //     <TotalGoldStaked />
// //   </Box>
// // );

// // export default Dashboard;

// const OperatorDashboard = ({ setHeaderName }) => {
//   useEffect(() => {
//     // setHeaderName("DashBoard")
//   }, []);

//   const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
//   const UserRole = sessionStorage.getItem("UserRole");

//   const dispatch = useDispatch();
//   const { getOperatorDashboardMetrics } = useSelector(
//     (state) => state?.getOperatorDashboardMetrics
//   );

//   console.log(getOperatorDashboardMetrics?.data, "getOperatorDashboardMetrics");

//   useEffect(() => {
//     const fetchData = async () => {
//       const data1 = {
//         data: {
//           operator_id: sessionOperator_id,
//           userRole: UserRole,
//         },
//         method: "post",
//         apiName: `getOperatorDashboardMetrics`,
//       };
//       await dispatch(actions.GETOPERATORDASHBOARDMETRICES(data1));
//     };
//     fetchData();
//   }, [dispatch]);

//   return (
//     <Grid container spacing={3}>
//       {" "}
//       {/* container with spacing */}
//       <Grid item xs={12} md={8}>
//         <Grid container spacing={3}>
//           {" "}
//           {/* container with spacing */}
//           <Grid item xs={12} md={6} sm={6}>
//             <StatusCard
//               icon={toal_user_icon}
//               header="Total Onbaoarding"
//               value="150"
//               componentPath="/total-onboarding"
//             />
//           </Grid>

//           <Grid item xs={12} md={6} sm={6}>
//             <StatusCard
//               icon={total_refer_icon}
//               header="Total Registration"
//               total_referral={true}
//               subheader1="Pending"
//               subheader2="completed"
//               value1={120}
//               value2={30}
//               componentPath="/total-regisration"
//             />
//           </Grid>
//           <Grid item xs={12} md={6} sm={6}>
//             <StatusCard
//               icon={total_register_icon}
//               header="Total Payment Received"
//               total_referral={true}
//               subheader1="Cash"
//               subheader2="Net Banking"
//               value1={120}
//               value2={30}
//               componentPath="/total-paymentreceived"
//             />
//           </Grid>
//           <Grid item xs={12} md={6} sm={6}>
//             <StatusCard
//               icon={gold_puschased_icon}
//               header="Total Transcation Completed"
//               total_referral={true}
//               subheader1="Cash"
//               subheader2="Net Banking"
//               value1={120}
//               value2={30}
//               componentPath="/total-transaction-complete"
//             />
//           </Grid>
//         </Grid>
//       </Grid>
//       <Grid item xs={12} md={4}>
//         <Grid item xs={12}>
//           <TotalGoldStaked />
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// };

// export default OperatorDashboard;

// ============================================================================
import React, { useEffect, useState } from "react";
import StatusCard from "../../../Components/StatusCard/StatusCard";
import { Button, Grid } from "@mui/material";
import toal_user_icon from "../../../Assets/toal_user_icon.svg";
import total_refer_icon from "../../../Assets/total_refer_icon.svg";
import total_register_icon from "../../../Assets/total_register_icon.svg";
import gold_puschased_icon from "../../../Assets/gold_puschased_icon.svg";
import toal_gold_matured_icon from "../../../Assets/toal_gold_matured_icon.svg";
import total_redeem_icon from "../../../Assets/total_redeem_icon.svg";
import { LuSquareChevronRight } from "react-icons/lu";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { CgChevronLeft, CgChevronLeftR, CgChevronRightR } from "react-icons/cg";

import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  Divider,
  Select,
  MenuItem,
} from "@mui/material";
import {
  ArrowBack,
  ArrowForward,
  ArrowLeft,
  ArrowRight,
  ArrowRightAltOutlined,
} from "@mui/icons-material";
import GradientLineChart from "../../../Components/GraphStake/GradientLineChart";
import TotalOnboarding from "./TotalOnboarding";
import actions from "../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";

// Gold Stake Schemes Component
const GoldStakeSchemesData = [
  {
    header: "Member Profit",
    subheader: "Since Last Month",
    value: "+53411",
  },
  {
    header: "Overdue",
    subheader: "Since Last Month",
    value: "+53411",
  },
  {
    header: "Support",
    subheader: "Since Last Month",
    value: "+53411",
  },
  {
    header: "Dividents",
    subheader: "Since Last Month",
    value: "+53411",
  },
];

const TotalGoldStaked = () => {
  const [selectedDate, setSelectedDate] = useState("Today");

  const [graphData, setGraphData] = useState({
    Today: {
      value: "$200.123",
      percentage: "+5.15(+20%)",
      stats: ["20% Growth", "40% Disbursed", "40% Withdraw"],
      graph: [
        { name: "Point 1", value: 20 },
        { name: "Point 2", value: 40 },
        { name: "Point 3", value: 25 },
        { name: "Point 4", value: 50 },
        { name: "Point 5", value: 35 },
      ],
    },
    Yesterday: {
      value: "$180.456",
      percentage: "+3.50(+15%)",
      stats: ["15% Growth", "50% Disbursed", "35% Withdraw"],
      graph: [
        { name: "Point 1", value: 10 },
        { name: "Point 2", value: 100 },
        { name: "Point 3", value: 20 },
        { name: "Point 4", value: 45 },
        { name: "Point 5", value: 25 },
      ],
    },
  });

  // Handler for dropdown change
  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const currentData = graphData[selectedDate];

  return (
    <Card
      sx={{
        paddingX: 2,
        py: 2,
        boxShadow: 2,
        height: "350px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="body1" fontWeight="bold" fontSize="17px">
          Total Gold Staked
        </Typography>

        <Select
          value={selectedDate}
          onChange={handleDateChange}
          size="small"
          variant="outlined"
          sx={{
            width: "80px",
            fontSize: "13px",
            height: "30px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#C38F51",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#C38F51",
            },
            "& .MuiSelect-select": {
              color: "#C38F51",
            },
          }}
        >
          <MenuItem value="Today">Today</MenuItem>
          <MenuItem value="Yesterday">Yesterday</MenuItem>
        </Select>
      </Box>
      <Divider sx={{ marginTop: 1, width: "100%" }} />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Typography
          variant="h3"
          fontWeight="bold"
          color="black"
          sx={{ fontSize: "28px" }}
        >
          {currentData.value}
        </Typography>
        <Typography variant="body2" color="#C38F51" fontSize="12px">
          {currentData.percentage}
        </Typography>
      </Box>
      {/* <GradientLineChart data={currentData} /> */}
      <GradientLineChart data={currentData.graph} />

      <Box
        sx={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}
      >
        {currentData.stats.map((stat, index) => (
          <Box key={index} textAlign="center">
            <Typography variant="body1" fontWeight="800">
              {stat.split(" ")[0]}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#C38F51", fontSize: "12px" }}
            >
              {stat.split(" ")[1]}
            </Typography>
          </Box>
        ))}
      </Box>
    </Card>
  );
};
// // Main Dashboard Component
// const Dashboard = () => (
//   <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 2, padding: 2 }}>
//     <GoldStakeSchemes />
//     <ReferralSchemes />
//     <TotalGoldStaked />
//   </Box>
// );

// export default Dashboard;

const OperatorDashboard = ({ setHeaderName }) => {
  useEffect(() => {
    // setHeaderName("DashBoard")
  }, []);

  const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
  const UserRole = sessionStorage.getItem("role");

  const dispatch = useDispatch();
  const { getOperatorDashboardMetrics } = useSelector(
    (state) => state?.getOperatorDashboardMetrics
  );

  console.log(getOperatorDashboardMetrics?.data, "getOperatorDashboardMetrics");

  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {
          operator_id: sessionOperator_id,
          userRole: UserRole,
        },
        method: "get",
        apiName: `getOperatorDashboardMetrics`,
      };
      await dispatch(actions.GETOPERATORDASHBOARDMETRICES(data1));
    };
    fetchData();
  }, [dispatch]);

  return (
    <Grid container spacing={3}>
      {" "}
      {/* container with spacing */}
      <Grid item xs={12} md={8}>
        <Grid container spacing={3}>
          {" "}
          {/* container with spacing */}
          <Grid item xs={12} md={6} sm={6}>
            <StatusCard
              icon={toal_user_icon}
              header="Total Onbaoarding"
              value={
                getOperatorDashboardMetrics?.data?.totalRegisteredUsers || 0
              }
              componentPath="/total-onboarding"
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <StatusCard
              icon={toal_user_icon}
              header="Total Purchase For Users"
              //   value="150"
              value={getOperatorDashboardMetrics?.data?.totalPurchaseCount || 0}
              componentPath="/total-purchase-users"
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <StatusCard
              icon={total_refer_icon}
              header="Total Payment Received"
              total_referral={true}
              subheader1="Cash"
              value1={
                getOperatorDashboardMetrics?.data?.totalCashPurchaseCount || 0
              }
              //   subheader2="completed"
            //   value1={120}
              //   value2={30}
              componentPath="/total-cashpaymentreceived"
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <StatusCard
              icon={toal_user_icon}
              header="Total Payment Received"
              total_referral={true}
              subheader1="Net  Banking"
              value1={
                getOperatorDashboardMetrics?.data?.totalNetBackPurchaseCount || 0
              }
              //   subheader2="completed"
            //   value1={120}
              componentPath="/total-netbankingpaymentreceived"
            />
          </Grid>
          {/* <Grid item xs={12} md={6} sm={6}>
            <StatusCard
              icon={total_refer_icon}
              header="Total Registration"
              total_referral={true}
              subheader1="Pending"
              subheader2="completed"
              value1={120}
              value2={30}
              componentPath="/total-regisration"
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <StatusCard
              icon={total_register_icon}
              header="Total Payment Received"
              total_referral={true}
              subheader1="Cash"
              subheader2="Net Banking"
              value1={120}
              value2={30}
              componentPath="/total-paymentreceived"
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <StatusCard
              icon={gold_puschased_icon}
              header="Total Transcation Completed"
              total_referral={true}
              subheader1="Cash"
              subheader2="Net Banking"
              value1={120}
              value2={30}
              componentPath="/total-transaction-complete"
            />
          </Grid> */}
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item xs={12}>
          <TotalGoldStaked />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OperatorDashboard;
